export interface ExtraProvider {
    celebrate(): void;
}

class Extra implements ExtraProvider {
    name = 'uber-extra-provider';

    providers: ExtraProvider[] = [];
    registerProvider(p: ExtraProvider) {
        this.providers.push(p);
    }

    celebrate(): void {
        for (const p of this.providers) p.celebrate();
    }
}

export const extra = new Extra();
